//cannot contain Dates, functions, Infinity, RegExps, Maps, Sets, Blobs, FileLists, ImageDatas, sparse Arrays, Typed Arrays or other complex types
export default {
  newCompany: undefined,
  newBrand: undefined,
  newShop: undefined,
  newUser: undefined,
  requestsCache: {},
  singleRequestCache: [],
};
